import React from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { Box, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { registrationLink } from "../../../../navigation/Navigation";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { JmfAuthFormContext } from "@mm-products/java-multima-framework";

export default function RegistrationLink() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const context = React.useContext(JmfAuthFormContext);
    if (!context) {
        return null;
    }
    const {
        state: { showForgotPassword, showPasswordReset },
    } = context;
    //
    const showLink = !showForgotPassword && !showPasswordReset;

    return showLink ? (
        <Box display="flex" sx={{ alignItems: "center", marginTop: "0.5rem" }}>
            <PersonAddIcon sx={{ marginRight: "0.5rem" }} />
            <Typography display="inline">
                {`${t("registration.registrationSentence1")} `}
                <Box component="span" fontWeight="bold">
                    {`${t("registration.registrationSentence2")} `}
                </Box>
                <Link href="" onClick={() => navigate({ pathname: registrationLink })}>
                    {t("registration.registrationSentenceLink")}
                </Link>
            </Typography>
        </Box>
    ) : null;
}
